// currency formatting utility
(function() {
  var currencyFormats = {
    JPY: { symbol: '¥', decimals: 0, code: 'JPY' },
    USD: { symbol: '$', decimals: 2, code: 'USD' },
    EUR: { symbol: '€', decimals: 2, code: 'EUR' },
    GBP: { symbol: '£', decimals: 2, code: 'GBP' },
    CAD: { symbol: '$', decimals: 2, code: 'CAD' },
    AUD: { symbol: '$', decimals: 2, code: 'AUD' },
    NZD: { symbol: '$', decimals: 2, code: 'NZD' },
    HKD: { symbol: '$', decimals: 2, code: 'HKD' },
    SGD: { symbol: '$', decimals: 2, code: 'SGD' },
    KRW: { symbol: '₩', decimals: 0, code: 'KRW' },
    CNY: { symbol: '¥', decimals: 2, code: 'CNY' },
    TWD: { symbol: '$', decimals: 0, code: 'TWD' },
    THB: { symbol: '฿', decimals: 2, code: 'THB' },
    INR: { symbol: '₹', decimals: 2, code: 'INR' },
    MYR: { symbol: 'RM', decimals: 2, code: 'MYR' },
    PHP: { symbol: '₱', decimals: 2, code: 'PHP' },
    VND: { symbol: '₫', decimals: 0, code: 'VND' },
    CHF: { symbol: 'CHF ', decimals: 2, code: 'CHF' },
    SEK: { symbol: 'kr', decimals: 2, code: 'SEK' },
    NOK: { symbol: 'kr', decimals: 2, code: 'NOK' },
    DKK: { symbol: 'kr', decimals: 2, code: 'DKK' },
    MXN: { symbol: '$', decimals: 2, code: 'MXN' },
    BRL: { symbol: 'R$', decimals: 2, code: 'BRL' }
  };

  var defaultFormat = { symbol: '', decimals: 2, code: '' };

  function formatMoney(amountInJPY) {
    var currency = (typeof Shopify !== 'undefined' && Shopify.currency) 
      ? Shopify.currency.active 
      : 'JPY';
    var rate = (typeof Shopify !== 'undefined' && Shopify.currency) 
      ? parseFloat(Shopify.currency.rate) 
      : 1;
    var convertedAmount = Math.round(amountInJPY * rate);
    var format = currencyFormats[currency] || { symbol: '', decimals: 2, code: currency };
    var formattedNumber = convertedAmount.toLocaleString('en-US', {
      minimumFractionDigits: format.decimals,
      maximumFractionDigits: format.decimals
    });
    return format.symbol + formattedNumber + ' ' + format.code;
  }

  function getActiveCurrency() {
    return (typeof Shopify !== 'undefined' && Shopify.currency) 
      ? Shopify.currency.active 
      : 'JPY';
  }

  function getCurrencyRate() {
    return (typeof Shopify !== 'undefined' && Shopify.currency) 
      ? parseFloat(Shopify.currency.rate) 
      : 1;
  }

  window.CurrencyFormat = {
    formatMoney: formatMoney,
    getActiveCurrency: getActiveCurrency,
    getCurrencyRate: getCurrencyRate
  };
})();